import axios from "../../utility/customAxios";

export interface PermissionDefinition {
    resource: string;
    operation: string;
}

export interface Role {
    uuid: string;
    name: string;
    description: string;
    permissions?: string[]; // Array of permission UUIDs
    isMetoroManaged: boolean;
}

export interface RolesResponse {
    roles: Role[];
}

export interface Permission {
    uuid: string;
    resource: string;
    operation: string;
    organizationUUID: string;
    isMetoroManaged: boolean;
}

interface ResourceDefinition {
    displayValue: string;
    value: string;
}

// Role operations
export const listRoles = async (): Promise<Role[]> => {
    const response = await axios.get<{roles: Role[]}>("/api/v1/roles");
    return response.data.roles;
};

export const createRole = async (name: string, description: string, permissions: PermissionDefinition[]): Promise<Role> => {
    const response = await axios.post<{role: Role}>("/api/v1/role", { name, description, permissions });
    return response.data.role;
};

export const updateRole = async (uuid: string, name: string, description: string, permissions: PermissionDefinition[]): Promise<Role> => {
    const response = await axios.put<{role: Role}>("/api/v1/role", { uuid, name, description, permissions });
    return response.data.role;
};

export const deleteRole = async (uuid: string): Promise<void> => {
    await axios.delete(`/api/v1/role?roleUUID=${encodeURIComponent(uuid)}`);
};

// Permission operations
export const listPermissions = async (): Promise<Permission[]> => {
    const response = await axios.get<{permissions: Permission[]}>("/api/v1/permissions");
    return response.data.permissions;
};
// User-Role operations
export const getUserRoles = async (userUUID: string): Promise<Role[]> => {
    const response = await axios.get<RolesResponse>(`/api/v1/user/roles?userUUID=${encodeURIComponent(userUUID)}`);
    return response.data && response.data.roles ? response.data.roles : [];
};

export const getUserPermissions = async (userUUID?: string): Promise<Permission[]> => {
    const additionaluserUUID = userUUID !== undefined ? `?userUUID=${encodeURIComponent(userUUID)}` : ""
    const response = await axios.get(`/api/v1/user/permissions` + additionaluserUUID);
    return response.data.permissions || []
};

export const assignRolesToUser = async (userUUID: string, roleUUIDs: string[]): Promise<void> => {
    await axios.post("/api/v1/user/roles", { userUUID, roleUUIDs });
};

export const removeRoleFromUser = async (userUUID: string, roleUUID: string): Promise<void> => {
    await axios.delete(`/api/v1/user/role?userUUID=${encodeURIComponent(userUUID)}&roleUUID=${encodeURIComponent(roleUUID)}`);
};

// Get available resources for permissions
export const getAvailableResources = async (): Promise<ResourceDefinition[]> => {
    const response = await axios.get<{resources: ResourceDefinition[]}>("/api/v1/permissions/resources");
    return response.data.resources;
}; 